<div ref:products style="height: {height}px">
	{#each truncatedProducts as p}
		<a href="{ p.href }" class="p { p.s == 2 && 'big' } c{ p.c }" style="transform: translate({ p.x * cellSize }px, { p.y * cellSize }px)">
			<img data-src="{ p.src }&w={ 150 * p.s }&dpr={ devicePixelRatio }" style="opacity: 0; width: { cellSize * p.s }px; height: { cellSize * p.s }px;" use:lazyload alt="{ p.name }" />
			{#if p.discount_fixed}
				<span class="discount">{p.below_map ? 'Sale' : `$` + p.discount_fixed.toFixed(2) + ' off'}</span>
			{:elseif p.discount_pct}
				<span class="discount">{(p.discount_pct < .1) || p.below_map ? 'Sale' : (p.discount_pct * 100) + '% off'}</span>
			{/if}
			<div class="name">{ p.name }</div>
			{#if !p.below_map}
				<div class="price">{ round(p.price) }</div>
			{/if}
		</a>
	{/each}
</div>

{#if truncate}<div class="truncate" on:click="set({ truncate: false })">[ Load { products.length - truncatedProducts.length } more products ]</div>{ /if }

<script>

	/* global THEME_VERSION */

	const xhr = resource => new Promise((res, rej) => {
		const xmlhr = new XMLHttpRequest()
		xmlhr.onload = function() {
			res(this)
		}
		xmlhr.onerror = function() {
			rej(this)
		}

		xmlhr.open(`GET`, resource)
		xmlhr.send()
	})

	function shuffle(a) {
		for (let i = a.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[ a[i], a[j] ] = [ a[j], a[i] ]
		}
		return a
	}

	function isAnyPartOfElementInViewport(el) {
		const rect = el.getBoundingClientRect()
		const windowHeight = (window.innerHeight || document.documentElement.clientHeight)
		return (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0)
	}

	export default {
		data: () => ({
			products: []
		}),
		helpers: {
			round: n => Math.round(n),
		},
		oncreate() {
			const { product_ids } = this.get()

			xhr(`/wp-json/product_grid/list?product_ids=${product_ids}`).then(o => {
				this.set({ productData: shuffle(JSON.parse(o.response)) })
			})

			this.set({ devicePixelRatio: window.devicePixelRatio })

			window.svelte = this

			window.addEventListener(`resize`, () => this.set({ width: this.refs.products.offsetWidth }))
			this.set({ width: this.refs.products.offsetWidth })
		},
		computed: {
			gridWidth: ({ width }) => Math.ceil(width / 150),
			cellSize: ({ width, gridWidth }) => width / gridWidth,
			cells: ({ productData, gridWidth }) => {
				if (!productData) {
					return []
				}

				let bigCells = 1
				let cells = new Array(productData.length)
				let attempts = 0

				while (bigCells < 100 && attempts < 100) {
					attempts++

					const gridHeight = Math.ceil(cells.length / gridWidth)

					// pick random cell
					const cellX = Math.floor(Math.random() * (gridWidth - 1))

					// must have at least 1 big tile on top row
					const cellY = bigCells == 1 ? 0 : Math.floor(Math.random() * (gridHeight - 1))

					const cell = (cellY * gridWidth) + cellX

					// collision detection
					if (cells[cell] == undefined
					&& cells[cell + 1] == undefined
					&& cells[cell + gridWidth] == undefined
					&& cells[cell + gridWidth + 1] == undefined) {
						const prevCellLength = cells.length

						// mark cells
						cells[cell] = bigCells // top left
						cells[cell + 1] = bigCells // top right
						cells[cell + gridWidth] = bigCells // bottom left
						cells[cell + gridWidth + 1] = bigCells // bottom right

						bigCells++

						// extra measures taken since adding a square occasionally creates new cells
						cells = [ ...cells, ...new Array(Math.max(3 - (cells.length - prevCellLength), 0)) ]
					}
				}

				return cells
			},
			products: ({ productData, cells, gridWidth }) => {
				if (!cells.length) {
					return []
				}

				// let table = ''

				const ps = []
				let pi = 0

				const visited = []

				for (let i = 0; i <= cells.length && pi < productData.length; i++) {
					// if((i % gridWidth) == 0) {
					// 	table += '\n'
					// }
					// table += cells[i] || 0

					let p

					if (cells[i] === undefined) { // single cell
						p = productData[pi]
						p.s = 1
					} else if (!visited[cells[i]]) { // new quad cell
						visited[cells[i]] = 1
						p = productData[pi]
						p.s = 2
					} else {
						continue // existing quad cell
					}

					Object.assign(p, {
						x: (i % gridWidth),
						y: Math.floor(i / gridWidth),
						c: Math.floor(Math.random() * 4),
					})

					pi++

					ps.push(p)
				}

				return ps
			},
			truncatedProducts: ({ products, truncate }) => truncate ? products.slice(0, 50) : products,
			height: ({ truncatedProducts, cellSize }) => truncatedProducts.reduce((max, p) => (p.y + p.s) * cellSize > max ? (p.y + p.s) * cellSize : max, 0),
		},
		actions: {
			lazyload(node) {
				function load() {
					if (isAnyPartOfElementInViewport(node)) {
						node.setAttribute(`src`, node.dataset.src)
					}
				}
				node.onload = () => {
					node.style.opacity = 1
				}
				window.addEventListener(`scroll`, load)
				window.addEventListener(`resize`, load)
				load()
			},
		},
	}

</script>

<style>

	ref:products {
		position: relative;
	}

	.truncate {
		margin-top:20px;
		cursor: pointer;
		font-size: 130%;
		color: #ceff51;
		text-align: center;
	}

	.p {
		position: absolute;
		top: 0;
		left: 0;
		color: #fff;
		font-family: 'Protipo Wide', sans-serif;
		cursor: pointer;
		font-size: 14px;
		transition: none;
	}

	.p .name {
		display: none;
		position: absolute;
		padding: 10px;
		background: #000;
		line-height: 1.5;
	}

	.p .price {
		position: absolute;
		font-size: 180%;
		opacity: 0.1;
		line-height: .8;
		text-align: right;
		padding: 5px 2px;

		/*&::before {
			font-size: 50%;
			content: '$';
			margin-right: 1px;
			vertical-align: middle;
		}*/
	}

	.p .discount {
		padding: 10px;
		background: #0000008a;
		position: absolute;
		letter-spacing: 3px;
		color: #647574;
		text-transform: uppercase;
		line-height: 1
	}

	@media (max-width: 600px) {

		.p .discount {
			font-size: 80%
		}
	}

	.p:hover {
		opacity: 1;
	}

	.p:hover .name {
		display: block;
	}

	.p:hover .discount {
		display: none;
	}

	.p:hover .price {
		opacity: 0.2;
	}

	.p.big {
		font-size: 18px;
	}

	.p.c0 .name, .p.c0 .discount { top: 0; left: 0; }

	.p.c0 .price { bottom: 0; right: 0; }

	.p.c1 .name, .p.c1 .discount { top: 0; right: 0; }

	.p.c1 .price { bottom: 0; left: 0; }

	.p.c2 .name, .p.c2 .discount { bottom: 0; right: 0; }

	.p.c2 .price { top: 0; left: 0; }

	.p.c3 .name, .p.c3 .discount { bottom: 0; left: 0; }

	.p.c3 .price { top: 0; right: 0; }

	.p img {
		width: 100%;
		transition: opacity .2s ease;
		display: block;
	}

</style>
